import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'testimonials',
            name: 'testimonial',
            class: 'Modules\\Site\\Entities\\Testimonial'
        }
    }
}